import useServiceFactory from "../serviceFactory";
const apiUrl = `/taller/inventariosCajas`;
const apiUrlSource = `/seguridad`;
const useApiInventariosCaja = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        filtrar: async (params) => service.get(`${apiUrl}`, { params, showLoading: true }),
        obtener: async (id) => service.get(`${apiUrl}/${id}`, { showLoading: true }),
        guardar: async (params) => service.post(`${apiUrl}`, params),
        subirInventario: async(fecha, formData) => service.post(`${apiUrl}/importar/${fecha}`, formData),
        excel: async (params) => service.get(`${apiUrl}/excel`,
            {
                params,
                showLoading: true,
                download: true,
                fileName: `InventariosCajas.xlsx`
            }),
        getPatios: async (username) =>
            service.get(`${apiUrlSource}/patiosUsuario`, {
                params: { username },
                showLoading: true,
            }),

        actualizarInventarioIpad: async (patioId, data, externo) =>
        service.put(
            `${apiUrl}/actualizarInventarioIpad/${patioId}/externo?externo=${externo}`,
            data 
        ),

        obtenerCargarConPatio: async (patioId,externo) =>  service.get(`${apiUrl}/obtenerCargarConPatio/${patioId}/externo`, { params: { externo } }),
        updateCaja: async (id, patioId,externo) => service.put(`${apiUrl}/${id}/cajas/${patioId}/externo?externo=${externo}`),
        updateCajas: async (patioId, data, externo) =>
        service.put(
            `${apiUrl}/updateCajas/${patioId}/externo?externo=${externo}`,
            data 
        ),

    }
};

export default useApiInventariosCaja;